<template>
  <div class="page page-map content">
    <MapEfriends />
  </div>
</template>

<script>
  import MapEfriends from '@/components/efriends/MapEfriends'

  export default {
    name: 'page-map',
    components: {
      MapEfriends,
    },
  }
</script>

<style lang="scss">
  .page-map {
    padding: 0 spacer(1);
  }

  $icon-color: $body-color;
  $icon-line-width: 3px;
  $icon-line-spacing: 3px;
  $icon-width: 1.3em;

  .icon-list {
    display: inline-block;
    width: $icon-width;
    margin-left: spacer(0.25);

    &__line-1,
    &__line-2,
    &__line-3 {
      content: '';
      height: $icon-line-width;
      background: $icon-color;
      display: block;
      transition: $transition-base;

      .page-map__toggle-sidebar--active & {
        background: $community;
      }
    }

    &__line-1 {
      margin-bottom: $icon-line-spacing;
    }

    &__line-2 {
      margin-bottom: $icon-line-spacing;
    }

    &__line-3 {
    }
  }
</style>
